// Mirrors MemberRole enum from avocash-group backend.
// `icon` is a Framework7 Icons ligature name; `color` is the role's accent
// color used to color-code the role in the role-change Action Sheet / Popover.
export const MEMBER_ROLES = [
  { code: 'OWNER',  label: 'member.role.owner',  desc: 'member.role.ownerDesc',  icon: 'star_fill',     color: '#C9A84C' },
  { code: 'ADMIN',  label: 'member.role.admin',  desc: 'member.role.adminDesc',  icon: 'shield_fill',   color: '#2563EB' },
  { code: 'MEMBER', label: 'member.role.member', desc: 'member.role.memberDesc', icon: 'person_fill',   color: '#1A6B42' },
  { code: 'GUEST',  label: 'member.role.guest',  desc: 'member.role.guestDesc',  icon: 'person_2_fill', color: '#6B7280' },
]

export function roleMeta(code) {
  return MEMBER_ROLES.find(r => r.code === code) ?? null
}

export function roleLabel(code) {
  return MEMBER_ROLES.find(r => r.code === code)?.label ?? code
}

// Roles an ADMIN is allowed to assign. OWNER is never assignable via the
// role-change sheet — ownership transfer is a separate, deliberate flow.
export const ASSIGNABLE_ROLES = ['ADMIN', 'MEMBER', 'GUEST']